module.exports = __webpack_public_path__ + "media/images/top/img_tab_chariloto_5-b790880e2d2d3033ba62504ed1139cdc.png";